export const RELEASE_MORTGAGE_LOADING = 'RELEASE_MORTGAGE_LOADING';

export const RELEASE_MORTGAGE_ERROR = 'RELEASE_MORTGAGE_ERROR';

export const INITIATE_RELEASE_MORTGAGE_APPLICATION_SUCCESS = 'INITIATE_RELEASE_MORTGAGE_APPLICATION_SUCCESS';

export const CLEAR_RELEASE_MORTGAGE_APPLICATION_ERROR = 'CLEAR_RELEASE_MORTGAGE_APPLICATION_ERROR';

export const FETCH_APPLICATION_RELEASE_MORTGAGE_SUCCESS = 'FETCH_APPLICATION_RELEASE_MORTGAGE_SUCCESS';

export const FETCH_DOCUMENTS_RELEASE_MORTGAGE_SUCCESS = 'FETCH_DOCUMENTS_RELEASE_MORTGAGE_SUCCESS';

export const RELEASE_MORTGAGE_CLEAR_DATA = 'RELEASE_MORTGAGE_CLEAR_DATA';

export const DOWNLOAD_DOCUMENT_RELEASE_MORTGAGE_SUCCESS = 'DOWNLOAD_DOCUMENT_RELEASE_MORTGAGE_SUCCESS';

export const RELEASE_MORTGAGE_CANCEL_APPLICATION_SUCCESS = 'RELEASE_MORTGAGE_CANCEL_APPLICATION_SUCCESS';

export const ADD_TO_ERROR = 'ADD_TO_ERROR';

export const CHANGE_RELEASE_MORTGAGE_STEP = 'CHANGE_RELEASE_MORTGAGE_STEP';

export const UPLOAD_RELEASE_MORTGAGE_DOCUMENT_SUCCESS = 'UPLOAD_RELEASE_MORTGAGE_DOCUMENT_SUCCESS';

export const SAVE_APPLICATION_RELEASE_MORTGAGE_SUCCESS = 'SAVE_APPLICATION_RELEASE_MORTGAGE_SUCCESS';

export const FETCH_MULTI_PROPERTIES_RELEASE_SUCCESS = 'FETCH_MULTI_PROPERTIES_RELEASE_SUCCESS';

export const FETCH_SINGLE_PROPERTY_DETAILS_SUCCESS = 'FETCH_SINGLE_PROPERTY_DETAILS_SUCCESS';

export const RESET_SINGLE_PROPERTY_DATA_IN_REDUCER = 'RESET_SINGLE_PROPERTY_DATA_IN_REDUCER';

export const LOADIND_IN_MODAL_START = 'LOADIND_IN_MODAL_START';

export const MORTGAGE_RELEASE_PAYMENT_PAYMENT_BREAKDOWN_SUCCESS = 'MORTGAGE_RELEASE_PAYMENT_PAYMENT_BREAKDOWN_SUCCESS';

export const MORTGAGE_RELEASE_APPROVAL_SUCCESS = 'MORTGAGE_RELEASE_APPROVAL_SUCCESS';

export const MORTGAGE_RELEASE_CLEAR_LOADING = 'MORTGAGE_RELEASE_CLEAR_LOADING';

export const FETCH_PROPERTY_OWNERS_SUCCESS = 'FETCH_PROPERTY_OWNERS_SUCCESS';

export const FETCH_MORTGAGE_CONTRACT_DETAILS_SUCCESS = 'FETCH_MORTGAGE_CONTRACT_DETAILS_SUCCESS';
